/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Missmatchdefectp12Inputs */



/**
* | output |
* | --- |
* | "Mismatch fault (left/top pump)" |
*
* @param {Ahu_History_Key_Missmatchdefectp12Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_missmatchdefectp12 = /** @type {((inputs?: Ahu_History_Key_Missmatchdefectp12Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Missmatchdefectp12Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Mismatch fault (left/top pump)")
	return /** @type {LocalizedString} */ ("Défaut de discordance pompe gauche/haute")
});
export { ahu_history_key_missmatchdefectp12 as "ahu_history_key_missmatchDefectP1" }